import { getErrorMessage } from '../utils/util.errors';
import services from './../config/services';
import axios from 'axios';
import {
	GET_ERRORS,
	FEATURED_PRODUCTS,
	DEACTIVATE_FEATURED_PRODUCTS,
	UPDATE_FEATURED_PRODUCTS
} from './types';

const URL_GET_FEATURED_PRODUCTS       = process.env.REACT_APP_API_URL + services.featuredProducts;
const URL_UPDATE_FEATURED_PRODUCTS    = process.env.REACT_APP_API_URL + services.updateFeaturedProducts;
const URL_DEACTIVATE_FEATURED_PRODUCT = process.env.REACT_APP_API_URL + services.deactivateFeaturedProduct;


export const GetFeaturedProducts = () => dispatch => {
	axios
		.get(URL_GET_FEATURED_PRODUCTS)
		.then((res) => {
			dispatch({
				type: FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const UpdateFeaturedProducts = (products) => dispatch => {
	axios
		.post(URL_UPDATE_FEATURED_PRODUCTS, { featuredProducts: products })
		.then((res) => {
			dispatch({
				type: UPDATE_FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const DeactivateFeaturedProduct = (product) => dispatch => {
	axios
		.post(URL_DEACTIVATE_FEATURED_PRODUCT, { featuredProduct: product })
		.then((res) => {
			dispatch({
				type: DEACTIVATE_FEATURED_PRODUCTS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}